import { render } from "./EditPoint.vue?vue&type=template&id=d2c3cb04&scoped=true"
import script from "./EditPoint.vue?vue&type=script&lang=js"
export * from "./EditPoint.vue?vue&type=script&lang=js"

import "./EditPoint.vue?vue&type=style&index=0&id=d2c3cb04&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c3cb04"]])

export default __exports__